import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Alert, Button, Card, Spin, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { IRootStoreProps, WithoutStore, withStore } from '../../../stores';
import { RoutesConfig } from '../../../config';

const Text = Typography.Text;
const routesConfig = new RoutesConfig();

class ConfirmEmail extends Component<IRootStoreProps> {
  componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search);
    const uuid = queryParams.get('uuid');
    const email = queryParams.get('email');

    if (uuid && email) {
      this.props.store.auth.confirmEmail(email, uuid);
    }
  }

  componentWillUnmount(): void {
    this.props.store.dispose();
  }

  goToHome = () => {
    if (this.props.store.user.isAuth) {
      return this.props.store.auth.logout();
    }
    this.props.store.navigation.goToPage(routesConfig.home);
  };

  render() {
    const { store } = this.props;

    return (
      <Card title="Подтверждение Email" style={{ width: '100%' }}>
        {store.requestSuccess ? (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <Text style={{ marginBottom: 60 }}>Ваш Email успешно подтвержден</Text>
            <br />
            <Button color="default" variant="outlined" onClick={this.goToHome}>
              На главную
            </Button>
          </div>
        ) : (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <Spin indicator={<LoadingOutlined spin />} size="large" style={{ marginBottom: 60 }} />
            {store.requestError && <Alert message="Ошибка" description={store.requestError} type="error" showIcon />}
          </div>
        )}
      </Card>
    );
  }
}

export const ConfirmEmailPage: WithoutStore = withStore(observer(ConfirmEmail));
